import { render, staticRenderFns } from "./StaticQuizPlay.vue?vue&type=template&id=49b22725&scoped=true"
import script from "./StaticQuizPlay.vue?vue&type=script&lang=js"
export * from "./StaticQuizPlay.vue?vue&type=script&lang=js"
import style0 from "./StaticQuizPlay.vue?vue&type=style&index=0&id=49b22725&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b22725",
  null
  
)

export default component.exports